import { useEffect, useState } from "react";
import { CreditCard, Mail, MessageCircle, Smartphone, UserCheck } from "lucide-react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((c) => { const t = localStorage.getItem("feemitra_token"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);
const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

function UsageTile({ icon: Icon, label, value, total, detail, testid }) {
  return <div className="usage-tile" data-testid={testid}>
    <div className="usage-tile-head"><Icon size={15} /><span>{label}</span></div>
    <strong data-testid={`${testid}-value`}>{value}{total !== undefined && <small> / {total}</small>}</strong>
    {total !== undefined && <div className="usage-bar"><i style={{ width: `${pct(value, total)}%` }} /></div>}
    <small className="muted">{detail}</small>
  </div>;
}

function ClassTable({ rows, onGuide }) {
  if (!rows?.length) return null;
  return <div className="usage-class" data-testid="usage-class-table">
    <h3>Class ke hisaab se</h3>
    <div className="table-wrap"><table><thead><tr><th>Class</th><th>Parents</th><th>Login kiya</th><th>30 din active</th><th>Online fee</th><th>Gmail bhara</th><th></th></tr></thead>
      <tbody>{rows.map(c => <tr key={c.label} data-testid={`usage-class-row-${c.label}`}>
        <td><strong>{c.label}</strong></td><td>{c.parents}</td>
        <td><span className={c.logged_in < c.parents ? "login-no" : "login-yes"}>{c.logged_in} / {c.parents}</span></td>
        <td>{c.active_30d}</td><td>{c.online_parents}</td><td>{c.email_filled} / {c.students}</td>
        <td>{c.logged_in < c.parents && <button className="pay-link" onClick={() => onGuide(c.class_name)} data-testid={`usage-class-guide-${c.label}`}><MessageCircle size={13} /> Guide bhejein</button>}</td>
      </tr>)}</tbody></table></div>
  </div>;
}

function MonthlyChart({ rows }) {
  if (!rows?.length) return null;
  return <div className="usage-monthly" data-testid="usage-monthly-chart">
    <div className="usage-chart"><h3>Naye parents (pehli baar login)</h3>
      <ResponsiveContainer width="100%" height={170}><BarChart data={rows}><CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="label" fontSize={11} /><YAxis allowDecimals={false} fontSize={11} width={28} /><Tooltip /><Bar dataKey="new_parents" name="Naye parents" fill="#1e3a8a" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer></div>
    <div className="usage-chart"><h3>Online fee (₹)</h3>
      <ResponsiveContainer width="100%" height={170}><BarChart data={rows}><CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="label" fontSize={11} /><YAxis fontSize={11} width={48} tickFormatter={(v) => v >= 1000 ? `${Math.round(v / 1000)}k` : v} /><Tooltip formatter={(v) => inr(v)} /><Bar dataKey="online_amount" name="Online fee" fill="#16a34a" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer></div>
  </div>;
}

export function ParentUsageCard({ onGuide }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/parent-usage").then(r => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === false) return null;
  return <section className="section-block parent-usage" data-testid="parent-usage-card">
    <div className="section-title"><div><h2>Parents ka app istemal</h2><p className="muted">Login ki ginti 13 Oct 2026 se shuru hui hai{d?.session ? ` · Online fee: session ${d.session}` : ""}</p></div>
      <button className="secondary-btn" onClick={() => onGuide("")} data-testid="parent-usage-guide-button"><MessageCircle size={15} /> Jinhone login nahi kiya, unhe guide bhejein</button></div>
    {!d ? <p className="muted" data-testid="parent-usage-loading">Loading…</p> : <div className="usage-grid">
      <UsageTile icon={UserCheck} label="Login kiya" value={d.logged_in} total={d.total_parents} detail={`${pct(d.logged_in, d.total_parents)}% parents`} testid="usage-logged-in" />
      <UsageTile icon={Smartphone} label="Pichhle 30 din mein active" value={d.active_30d} total={d.total_parents} detail="Haal hi mein app khola" testid="usage-active" />
      <UsageTile icon={CreditCard} label="Online fee bhari" value={d.online_parents} total={d.total_parents} detail={`${inr(d.online_amount)} · ${d.online_payments} payments`} testid="usage-online" />
      <UsageTile icon={Mail} label="Gmail bhara hai" value={d.email_filled} total={d.students} detail="Bachchon ka parent email" testid="usage-email" />
    </div>}
    {d && <MonthlyChart rows={d.monthly} />}
    {d && <ClassTable rows={d.by_class} onGuide={onGuide} />}
  </section>;
}
